.card {
    margin: 16px;
}

.cardBody {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
}

.logo {
    width: 80%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.heading {
    width: 100%;
    margin-top: 1rem;
}
